<script setup>
import { ref, inject, watch } from 'vue'
import axios from 'axios'

const userStore = inject('userStore')

// De links komen uit /api/backoffice en niet uit de HTML: pagina's worden met
// de responsecache opgeslagen, dus alles wat in de HTML staat zou aan iedere
// bezoeker worden getoond.
const links = ref([])

watch(() => userStore.user, (user) => {
    if (! user?.isAdmin) {
        links.value = []

        return
    }

    axios
        .get('/api/backoffice', { params: { path: window.location.pathname } })
        .then(response => {
            links.value = response.data.data
        })
        .catch(e => {
            links.value = []
        })
}, { immediate: true })

const isOpen = ref(false)

function toggle () {
    isOpen.value = !isOpen.value
}
</script>

<template>
    <div v-if="links.length > 0" class="fixed bottom-1/2 -translate-y-1/2 right-5 z-[99] flex flex-col justify-center">
        <div class="flex justify-center">
            <button @click="toggle" class="bg-red-500 text-white p-5 rounded-full shadow-lg cursor-pointer flex-none">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none">
                    <path d="M20.6887 3.93395L20.0661 3.31132C19.651 2.89623 18.978 2.89623 18.5629 3.31131L15.2141 6.66008C14.769 7.10522 14.4656 7.67217 14.3421 8.28947L14 10L15.7105 9.65789C16.3278 9.53443 16.8948 9.23101 17.3399 8.78587L20.6887 5.43711C21.1038 5.02202 21.1038 4.34903 20.6887 3.93395Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M13.6903 19.4567C13.5 18.9973 13.5 18.4149 13.5 17.25C13.5 16.0851 13.5 15.5027 13.6903 15.0433C13.944 14.4307 14.4307 13.944 15.0433 13.6903C15.5027 13.5 16.0851 13.5 17.25 13.5C18.4149 13.5 18.9973 13.5 19.4567 13.6903C20.0693 13.944 20.556 14.4307 20.8097 15.0433C21 15.5027 21 16.0851 21 17.25C21 18.4149 21 18.9973 20.8097 19.4567C20.556 20.0693 20.0693 20.556 19.4567 20.8097C18.9973 21 18.4149 21 17.25 21C16.0851 21 15.5027 21 15.0433 20.8097C14.4307 20.556 13.944 20.0693 13.6903 19.4567Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                    <path d="M3.1903 19.4567C3 18.9973 3 18.4149 3 17.25C3 16.0851 3 15.5027 3.1903 15.0433C3.44404 14.4307 3.93072 13.944 4.54329 13.6903C5.00272 13.5 5.58515 13.5 6.75 13.5C7.91485 13.5 8.49728 13.5 8.95671 13.6903C9.56928 13.944 10.056 14.4307 10.3097 15.0433C10.5 15.5027 10.5 16.0851 10.5 17.25C10.5 18.4149 10.5 18.9973 10.3097 19.4567C10.056 20.0693 9.56928 20.556 8.95671 20.8097C8.49728 21 7.91485 21 6.75 21C5.58515 21 5.00272 21 4.54329 20.8097C3.93072 20.556 3.44404 20.0693 3.1903 19.4567Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                    <path d="M3.1903 8.95671C3 8.49728 3 7.91485 3 6.75C3 5.58515 3 5.00272 3.1903 4.54329C3.44404 3.93072 3.93072 3.44404 4.54329 3.1903C5.00272 3 5.58515 3 6.75 3C7.91485 3 8.49728 3 8.95671 3.1903C9.56928 3.44404 10.056 3.93072 10.3097 4.54329C10.5 5.00272 10.5 5.58515 10.5 6.75C10.5 7.91485 10.5 8.49728 10.3097 8.95671C10.056 9.56928 9.56928 10.056 8.95671 10.3097C8.49728 10.5 7.91485 10.5 6.75 10.5C5.58515 10.5 5.00272 10.5 4.54329 10.3097C3.93072 10.056 3.44404 9.56928 3.1903 8.95671Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                </svg>
                <span></span>
            </button>
        </div>
        <div v-if="isOpen" class="absolute right-20 top-0 bg-white border border-gray-200 p-4 rounded shadow-lg w-[10rem] flex flex-col gap-1">
            <a v-for="link in links" :href="link.url" target="_blank" class="flex justify-center text-gray-600 text-sm rounded-sm border border-gray-200 hover:border-red-500 hover:font-bold hover:bg-red-500 hover:text-white px-3 py-2">{{ link.label }}</a>
        </div>
    </div>
</template>
